<template>
	<div v-loading="loading">
		<el-space :spacer="spacer" :size="4">
			<span>Data Jenis Moda Transportasi</span>
			<el-tooltip content="Tambah data">
				<el-button type="info" size="small" icon="Plus" plain round @click="dialogCreateVisible = true" />
			</el-tooltip>
		</el-space>
		<hr />
		<el-form @submit.prevent="updateData">
			<el-table :data="tableData" row-key="moda_transportasi_id">
				<el-table-column type="index" label="No." />
				<el-table-column label="Jenis" prop="jenis">
					<template #default="{ row }">
						<transition name="fade" mode="out-in">
							<el-input type="text" v-model="formEdit" :placeholder="row.jenis" v-if="editing === row" />
							<span v-else :key="row.jenis">{{ row.jenis }}</span>
						</transition>
					</template>
				</el-table-column>
				<el-table-column label="Diperbarui" prop="last_update">
					<template #default="{ row }">
						<transition name="fade" mode="out-in">
							<span :key="row.last_update">{{ row.last_update }}</span>
						</transition>
					</template>
				</el-table-column>
				<el-table-column label="Tindakan">
					<template #default="{ row }">
						<transition name="fade" mode="out-in">
							<el-space :spacer="spacer" :size="2" v-if="editing === row">
								<el-button type="info" size="small" plain round @click="edit">Batal</el-button>
								<el-button type="success" size="small" round native-type="submit" :loading="loadingEdit">Simpan</el-button>
							</el-space>
							<el-space :spacer="spacer" :size="2" v-else>
								<el-tooltip content="Edit data">
									<el-button type="primary" size="small" icon="Edit" plain round @click="edit(row)" />
								</el-tooltip>
								<el-tooltip content="Hapus data">
									<el-button type="danger" size="small" icon="Delete" plain round :loading="deleting === row" @click="confirmDelete(row)" />
								</el-tooltip>
							</el-space>
						</transition>
					</template>
				</el-table-column>
			</el-table>
		</el-form>
		<el-form :model="formCreate" :rules="rules" ref="formCreate" @submit.prevent="insertData" :disabled="inserting">
			<el-dialog v-model="dialogCreateVisible" title="Tambah Data" align-center :width="modalWidth">
				<el-form-item prop="jenis">
					<el-input v-model="formCreate.jenis" placeholder="Jenis moda transportasi" />
				</el-form-item>
				<template #footer>
					<el-button type="info" plain @click="dialogCreateVisible = false">Batal</el-button>
					<el-button type="success" native-type="submit" :loading="inserting">Simpan</el-button>
				</template>
			</el-dialog>
		</el-form>
	</div>
</template>

<script>
import { ElDivider } from "element-plus";
import { h } from "vue";
export default {
	name: "ModaTransportasi",
	data() {
		return {
			spacer: h(ElDivider, { direction: "vertical" }),
			dialogCreateVisible: false,
			formCreate: {
				jenis: null,
			},
			rules: {
				jenis: [{ required: true, message: "Masukkan jenis moda transportasi", trigger: "change" }],
			},
			inserting: false,
			editing: null,
			formEdit: null,
			loadingEdit: false,
			deleting: null,
		};
	},
	props: {
		dataPendukung: Object,
		loadingData: Object,
		updateEditing: Function,
		modalWidth: String,
	},
	computed: {
		tableData() {
			return this.dataPendukung["moda_transportasi"];
		},
		loading() {
			return this.loadingData["moda_transportasi"];
		},
	},
	watch: {
		formEdit(val) {
			if (val) this.updateEditing(true);
			else this.updateEditing(false);
		},
		dialogCreateVisible() {
			this.$refs.formCreate.resetFields();
		},
	},
	mounted() {},
	beforeUnmount() {},
	beforeRouteLeave(to, from, next) {
		if (this.formEdit) {
			const answer = window.confirm("Perubahan belum disimpan. Apakah Anda yakin ingin meninggalkan halaman ini?");
			if (answer) {
				this.updateEditing(false);
				next();
			} else {
				next(false);
			}
		} else {
			next();
		}
	},
	methods: {
		edit(row = null) {
			this.formEdit = null;
			if (row) this.editing = row;
			else this.editing = null;
		},
		confirmDelete(row) {
			this.$confirm("", "Perhatian", {
				message: h("div", {}, ["Anda yakin ingin menghapus jenis moda transportasi ", h("mark", { class: "fw-bold" }, row.jenis), "?"]),
				confirmButtonText: "Ya, hapus",
				cancelButtonText: "Batal",
				type: "warning",
			})
				.then(() => this.deleteData(row))
				.catch(() => {});
		},
		async insertData() {
			this.inserting = true;
			try {
				const valid = await this.$refs.formCreate.validate((res) => {
					return res;
				});
				if (!valid) {
					throw Error("Silakan masukkan isian sesuai dengan ketentuan");
				}
				const { data } = await this.$defaultApi.post("/data/moda-transportasi/create", this.formCreate);

				this.dialogCreateVisible = false;
				this.$notify.success({
					title: "Berhasil",
					message: data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.inserting = false;
				}, 500);
			}
		},
		async updateData() {
			this.loadingEdit = true;
			try {
				if (!this.formEdit) {
					throw Error("Belum ada perubahan");
				}

				const { data } = await this.$defaultApi.post("/data/moda-transportasi/update", {
					moda_transportasi_id: this.editing.moda_transportasi_id,
					jenis: this.formEdit,
				});

				this.formEdit = null;
				this.editing = null;
				this.$notify.success({
					title: "Berhasil",
					message: data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.loadingEdit = false;
				}, 500);
			}
		},
		async deleteData(row) {
			this.deleting = row;
			try {
				const { data } = await this.$defaultApi.post("/data/moda-transportasi/delete", {
					moda_transportasi_id: row.moda_transportasi_id,
				});

				this.$notify.success({
					title: "Berhasil",
					message: data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.deleting = null;
				}, 500);
			}
		},
	},
};
</script>

<style scoped></style>
